<template>
  <div class="setting-guide-renderer">
    <template v-for="block in blocks" :key="block.id">
      <h1 v-if="block.type === 'title'" class="doc-title">{{ t(block.textKey) }}</h1>

      <div v-else-if="block.type === 'paragraph'" class="doc-paragraph">
        {{ t(block.textKey) }}
      </div>

      <div v-else-if="block.type === 'richText'" class="doc-paragraph">
        <template v-for="segment in block.segments" :key="segment.textKey">
          <span
            :class="{
              'text-strong': segment.strong,
              'text-danger': segment.danger,
            }"
          >
            {{ t(segment.textKey) }}
          </span>
        </template>
      </div>

      <div v-else-if="block.type === 'list'" class="doc-list-wrap">
        <div v-if="block.titleKey" class="doc-paragraph">{{ t(block.titleKey) }}</div>
        <ul class="doc-list">
          <li v-for="(item, index) in block.items" :key="`${block.id}-${index}`">
            <template v-if="item.textKey">
              {{ t(item.textKey) }}
            </template>
            <template v-else>
              <template v-for="segment in item.segments" :key="segment.textKey">
                <span
                  :class="{
                    'text-strong': segment.strong,
                    'text-danger': segment.danger,
                  }"
                >
                  {{ t(segment.textKey) }}
                </span>
              </template>
            </template>
          </li>
        </ul>
      </div>

      <div v-else-if="block.type === 'image'" class="doc-image">
        <ImageShow :url="imageMap[block.imageKey]" />
      </div>
    </template>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import ImageShow from "@/views/FileDoc/components/ImageShow.vue";

defineProps({
  blocks: {
    type: Array,
    default: () => [],
  },
  imageMap: {
    type: Object,
    default: () => ({}),
  },
})

const {t} = useI18n()
</script>

<style scoped lang="less">
.setting-guide-renderer {
  width: 100%;
}

.doc-title {
  margin: 0 0 24px;
}

.doc-paragraph {
  margin: 24px 0;
  line-height: 1.75;
}

.doc-list-wrap {
  margin: 24px 0;
}

.doc-list {
  margin: 16px 0 0;
  padding-left: 20px;
  line-height: 1.75;
}

.doc-list li + li {
  margin-top: 8px;
}

.doc-image {
  margin: 24px 0;
}

.text-strong {
  font-weight: 500;
}

.text-danger {
  color: var(--el-color-danger);
}
</style>
